export default /*@ngInject*/ function ($rootScope, connectionsDataService, dataService, $filter, helperService) {
    const vm = this;

    vm.$onInit = init;
    vm.$onChanges = navigateForm;
    vm.typesChanged = typesChanged;
    vm.saveProductLogo = saveProductLogo;
    vm.updateDataMapping = updateDataMapping;

    vm.connectionTypes = [];
    vm.productTypesDataSource = [];

    const keys = ["Name"];

    async function init() {
        vm.customProductType = {
            Type: 'Custom',
            Name: 'Custom',
            ModuleId: 10000
        },
        vm.atProductType = {
            Type: 'AuditTrail',
            Name: 'Change Tracking',
            ModuleId: 3000
            };

        vm.mappingTypes = [
            "Simple",
            "Advanced"
        ];

        let response;

        try {
            response = await dataService.getProductTypes();

            if (vm.productTypesDataSource.length === 0) {
                vm.productTypesDataSource.unshift(vm.customProductType);

                if (response.data.some(prod => prod.Type === 'SAP')) {
                    const obj = response.data.find(prod => prod.Type === 'SAP');
                    obj.ModuleId = 10000;
                    vm.productTypesDataSource.push(obj);
                }

                if (vm.modules.some(item => item.ObjectID === vm.atProductType.ModuleId)) {
                    vm.productTypesDataSource.unshift(vm.atProductType);
                }
            }

            if (vm.product?.Type === 'SAP') {
                vm.selectedProductType = vm.productTypesDataSource.find(pt => pt.Type === vm.product.Type);
            } else {
                vm.selectedProductType = vm.product?.Type?.Type === 'AuditTrail' || vm.product?.HasAuditTrailModule || vm.selectedProductType?.ModuleId === 3000 ? vm.atProductType : vm.customProductType;
            }

        } catch (response) {
            helperService.showErrorMessage(response.data);
        }

        getTypes();
        updateDataMapping();
    }

    function typesChanged() {
        if (vm.selectedDataSource?.Name == 'REST API' && vm.isCreate) {
            vm.product.CustomDataMappingEnabled = true;
        }
        updateDataMapping();
        if (vm.selectedProductType.ModuleId === 3000) {
            vm.selectedDataSource = vm.dataSourceTypes.find(dataSource => dataSource.Name === 'Microsoft SQL');
            vm.updateHiddenSteps(2, false);
        } else if (vm.selectedProductType.Type === 'SAP') {
            vm.dataSourceTypes.push(vm.sapDataSource);
            vm.selectedDataSource = vm.sapDataSource;
            vm.updateHiddenSteps(3, true);
            vm.updateHiddenSteps(2, true);
        } else if (vm.selectedProductType.ModuleId === vm.customProductType.ModuleId && (!vm.selectedDataSource.IsFileBased || vm.selectedDataSource.Id === 2)) {
            vm.updateHiddenSteps(2, false);
        } else {
            vm.dataSourceTypes = vm.dataSourceTypes.filter(dataSource => dataSource !== vm.sapDataSource);
            vm.selectedDataSource = vm.dataSourceTypes[0];
            vm.updateHiddenSteps(2, true);
        }

        vm.product.Type = vm.selectedProductType;
        vm.product.DataSource = vm.selectedDataSource;

        const product = vm.product;
        vm.saveStep(product, keys);
    }

    function updateDataMapping() {
        if (!vm.product.CustomDataMappingEnabled) {
            vm.product.ObjectLevelDataAnalysisEnabled = false;
            vm.updateHiddenSteps(3, true);
            vm.updateHiddenSteps(4, true);
        } else if (vm.product.CustomDataMappingEnabled && vm.isCreate) {
            vm.product.ObjectLevelDataAnalysisEnabled = true;
            vm.product.CustomProductMappingType = vm.mappingTypes.find(map => map === 'Simple');
            vm.updateHiddenSteps(3, false);
        } else {
            vm.updateHiddenSteps(3, false); 
        }
    }

    async function getTypes() {
        vm.dataSourceTypesLoading = true;
        try {
            const response = await connectionsDataService.getUpiDataSources();
            response.data = $filter('orderBy')(response.data, "Name");
            vm.dataSourceTypes = response.data.filter(datasource => datasource.IsUPIConnectionType);

            if (vm.productTypesDataSource.some(prod => prod.Type === 'SAP')) {
                vm.sapDataSource = response.data.find(datasource => !datasource.IsUPIConnectionType);
            }

            if (vm.selectedProductType.ModuleId === 3000) {
                vm.selectedDataSource = vm.dataSourceTypes.find(dataSource => dataSource.Name === 'Microsoft SQL');
            } else if (vm.product && !vm.product?.DataSource) {
                vm.selectedDataSource = vm.dataSourceTypes.find(dataSource => dataSource.Id === 3);
            } else if (vm.product?.DataSource?.Name) {
                vm.product.DataSource.Name = vm.product.DataSource.Name.replace(/([a-z])([A-Z])/g, '$1 $2');
                vm.selectedDataSource = vm.dataSourceTypes.find(dataSource => dataSource.Name.toUpperCase() === vm.product.DataSource.Name.toUpperCase());
            } else {
                vm.selectedDataSource = vm.dataSourceTypes[0];
            }

            await typesChanged();
            vm.dataSourceTypesLoading = false;
        } catch {
            vm.dataSourceTypesLoading = false;
        }
    }

    function saveProductLogo(file) {
        vm.product.LogoFlow = file;
    }

    async function navigateForm() {
        const product = vm.product;

        if (vm.product.LogoFlow?.flowObj) {
            vm.product.LogoFlow = vm.product.LogoFlow.flowObj.files[0];
        }

        vm.saveStep(product, keys);
    }
}